import { IComboBoxOption } from '@fluentui/react';
import { PodProviderCategory } from '../api/pods.types';

export const MEDICARE_PAYER_ID = '0001444190950393-c6983382190f-0010';

export const PCP_TYPE = [
  { key: 'NO_ATTRIBUTION', text: 'No Attribution' },
  { key: 'ATTRIBUTED_BY_HEAL', text: 'Attributed by Heal' },
  { key: 'REQUEST_SENT_TO_PAYER', text: 'Request sent to payer' },
  { key: 'REQUEST_SENT_TO_PAYER_FAILED', text: 'Request sent to payer failed' },
  { key: 'REQUEST_ACKNOWLEDGED_BY_PAYER', text: 'Request acknowledged by payor' },
  { key: 'ATTRIBUTED_BY_PAYER', text: 'Attributed by payer' },
  { key: 'DECLINED_BY_PATIENT', text: 'Declined by patient' },
  { key: 'DECLINED_BY_PAYER', text: 'Declined by payer' },
  { key: 'DECLINED_BY_HEAL', text: 'Declined by Heal' },
];

export const PCP_ENABLED = ['ATTRIBUTED_BY_HEAL', 'REQUEST_SENT_TO_PAYER', 'REQUEST_SENT_TO_PAYER_FAILED', 'REQUEST_ACKNOWLEDGED_BY_PAYER', 'ATTRIBUTED_BY_PAYER'];

export const PCP_CONSENT_TYPE = [
  { key: 'TELEPHONE_OUTREACH', text: 'Telephone outreach' },
  { key: 'PARTNER_PORTAL', text: 'Partner portal' },
  { key: 'PREATTRIBUTED_BY_PAYER', text: 'Pre-attributed by payer' },
  { key: 'TELEMEDICINE_ENCOUNTER', text: 'Telemedicine encounter' },
  { key: 'IN_PERSON_ENCOUNTER', text: 'In-person encounter' },
];

export const PCP_DECLINE_TYPE = [
  { key: 'DECLINED_BY_PATIENT', text: 'Declined by patient' },
  { key: 'DECLINED_BY_PAYER', text: 'Declined by payer' },
  { key: 'DECLINED_BY_HEAL', text: 'Declined by Heal' },
];

export const PCP_PAYER_TYPE = [
  { key: 'pcp-attribution-aetna', text: 'Attributed by Aetna' },
  { key: 'pcp-attribution-humana', text: 'Attributed by Humana' },
  { key: 'pcp-attribution-wellcare', text: 'Attributed by Wellcare' },
];

export const PATIENT_TYPE = [
  { key: '0001433013870063-d279fc27ffff816b-0006', text: 'Spouse' },
  { key: '0001433013870063-d279fc27ffff816b-0007', text: 'Partner' },
  { key: '0001433013870063-d279fc27ffff816b-0011', text: 'Grandparent' },
  { key: '0001433013870063-d279fc27ffff816b-0009', text: 'Grandchild' },
  { key: '0001433013870063-d279fc27ffff816b-0008', text: 'Child' },
  { key: '0001433013870063-d279fc27ffff816b-0010', text: 'Parent' },
  { key: '0001433013870063-d279fc27ffff816b-0005', text: 'Sibling' },
  { key: '0001433013870063-d279fc27ffff816b-0014', text: 'Other' },
  { key: '0001433013870063-d279fc27ffff816b-0004', text: 'You', main: true },
  { key: '0001433013870063-d279fc27ffff816b-0013', text: 'Friend' },
  { key: '0001433013870063-d279fc27ffff816b-0012', text: 'Coworker' },
  { key: '0001433013870063-d279fc27ffff816b-0015', text: 'Assisted Living Resident' },
  { key: '0001433013870063-d279fc27ffff816b-0016', text: 'Skilled Nursing Facility' },
];

export const GENDER_TYPE = [
  { key: '0001433013870063-d279fc27ffff816b-0002', text: 'Female' },
  { key: '0001433013870063-d279fc27ffff816b-0001', text: 'Male' },
  { key: '0001433013870063-d279fc27ffff816b-0003', text: 'Other' },
];

export const AGENCY_PAYMENT_TERM_TYPE = [
  {
    key: 'INVOICE',
    text: 'Invoice',
    description: 'Visits booked through this agency will incur no charge at checkout. Heal will send a monthly invoice to receive payment from this agency.',
  },
  {
    key: 'INSURANCE_ONLY',
    text: 'Insurance Only',
    description: 'Visits booked through this agency will require the use of patient insurance at checkout. Cash-pay visits are prohibited.',
  },
  {
    key: 'CREDIT_CARD_ONLY',
    text: 'Credit Card Only',
    description: 'Visits booked through this agency will prohibit the use of insurance at checkout. Cash-pay alone is permitted.',
  },
];

export const AGENCY_FLAG_TYPE = [
  {
    key: 'CANNOT_RESCHEDULE_OR_CANCEL',
    text: 'Prohibit rescheduling/canceling visits',
    description: 'When enabled, agents will not be able to reschedule or cancel visits on behalf of member patients.',
  },
  {
    key: 'CANNOT_VIEW_FILES',
    text: 'Prohibit viewing files',
    description: 'When enabled, agents will not be able to view clinical files of member patients.',
  },
  {
    key: 'CANNOT_UPLOAD_FILES',
    text: 'Prohibit uploading files',
    description: 'When enabled, agents will not be able to upload files for patients during the booking process.',
  },
  {
    key: 'CANNOT_REPLACE_FILES',
    text: 'Prohibit replacing files',
    description: 'When enabled, agents will not be able to replace/overwrite existing files for patients.',
  },
  {
    key: 'REFERRAL_SOURCE',
    text: 'Show agency as a referral source',
    description: 'When enabled, this agency will be available as a referral source.',
  },
  {
    key: 'CAN_SKIP_ATTRIBUTION',
    text: 'Allow skipping patient attribution',
    description: 'When enabled, this agency can skip the attribution process in the booking experience.',
  },
];

export const DOCUMENT_TYPE = [
  { key: 'carePlan', text: 'Clinical Care Plan' },
  { key: 'agreement', text: 'Agreement' },
  { key: 'labResult', text: 'Lab Results' },
  { key: 'superbill', text: 'Superbill' },
  { key: 'medicalRecord', text: 'Medical Records' },
  { key: 'physicianReport', text: 'Physician’s Report' },
  { key: 'medicalLeave', text: 'Medical Leave' },
  { key: 'vaccination', text: 'Vaccination' },
  { key: 'vaccinations', text: 'Vaccination' },
  { key: 'referral', text: 'Referral' },
  { key: 'avatar', text: 'Avatar' },
  { key: 'other', text: 'Other' },
  { key: 'form', text: 'PCP Attribution' },
  { key: 'deathCertificate', text: 'Death Certificate' },
];

export const DISALLOWED_UPLOAD_DOC_TYPES = ['vaccination', 'vaccinations', 'form', 'deathCertificate'];

export const CHARGE_TYPE = [
  { key: 'NO_SHOW', text: 'No Show' },
  { key: 'NO_LEGAL_GUARDIAN', text: 'No Legal Guardian' },
  { key: 'VACCINATION', text: 'Vaccination' },
  { key: 'NEW_VISIT', text: 'New Visit' },
  { key: 'OTHER', text: 'Other' },
];

export const ADDRESS_TYPES = [
  {
    type: 'HOME',
    label: 'home',
    iconName: 'Home',
  },
  {
    type: 'WORK',
    label: 'work',
    iconName: 'Work',
  },
  {
    type: 'OTHER',
    label: 'other',
    iconName: 'MapPin',
  },
];

export const PARTNER_ADDRESS_TYPE = [
  {
    key: 'CORPORATE_FACILITY',
    text: 'Corporate Facility',
  },
  {
    key: 'HOUSING_FACILITY',
    text: 'Housing Facility',
  },
];

export const SYMPTOMS_HIGHLIGHTS: string[] = [
  'pain',
  'vaginal',
  'rectal',
  'anus',
  'anal',
  'pelvic',
  'vomit',
  'surgery',
  'surgical',
  'animal',
  'burn',
  'burnt',
  'bite',
  'bitten',
  'bit',
  'blood',
  'bleed',
  'bled',
  'clot',
  'burn',
  'bone',
  'dizzy',
  'eye',
  'blurry',
  'choke',
  'choking',
  'choked',
  'suicide',
  'seizure',
  'conscious',
  'drown',
  'oxygen',
  'trauma',
  'allergic',
  'epipen',
  'reaction',
  'hives',
  'swelling',
  'emergency',
  'newborn',
  'drool',
  'poison',
  'scrotum',
  'testicle',
  'testes',
  'baseball',
  'travel',
  'alcohol',
  'drug',
  'substance',
  'chest',
  'pressure',
  'breathe',
  'breath',
  'quickly',
  'blue',
  'red',
  'shortness',
  'vomiting',
  'incision',
  'unconscious',
  'racing',
  'head',
  'dizzy',
  'vertigo',
  'confused',
  'delirious',
  'delirium',
  'lethargic',
  'fatigue',
  'numb',
  'numbness',
  'stroke',
  'weak',
  'severe',
  'stab',
  'stabbing',
  'foul',
  'panic',
  'anxiety',
  'attack',
  'heart',
  'fell',
  'fall',
  'cut',
  'knife',
  'stuck',
  'skull',
  'fontanelle',
  'lockjaw',
  'locked jaw',
  'trismus',
];

export const PATIENT_LANGUAGES: { [key: string]: string } = {
  en: 'English',
  es: 'Spanish',
};

export const SUPPORT_STAFF_POSITIONS = ['Patient Support Coordinator', 'Patient Care Coordinator', 'Medical Assistant'];

export const MAX_PATIENTS_BY_CATEGORY: { [Property in PodProviderCategory]: number } = {
  Physician: 500,
  Clinician: 500,
  'Support Staff': 400,
};

export const MAX_POD_CLINICIANS = 4;

export const CLINICIAN_SUFFIX_OPTIONS: IComboBoxOption[] = [
  { key: 'MD', text: 'MD' },
  { key: 'DO', text: 'DO' },
  { key: 'NP', text: 'NP' },
  { key: 'DNP', text: 'DNP' },
  { key: 'PA', text: 'PA' },
  { key: 'LVN/LPN', text: 'LVN/LPN' },
  { key: 'RN', text: 'RN' },
];

export const SUPPORT_STAFF_SUFFIX_OPTIONS: IComboBoxOption[] = [
  { key: 'MA', text: 'MA' },
  { key: 'PCC', text: 'PCC' },
  { key: 'PSC', text: 'PSC' },
];

export const CENTERWELL_CENTERS = [
  { id: 1, name: 'CW Old National', address: '6085 Old National Hwy, Suite G, Atlanta, CA 30349', coordinates: [33.590143, -84.47035389999999] },
  { id: 2, name: 'CW Morrow', address: '1821 Mt. Zion Rd., Morrow, GA 30260', coordinates: [33.5693254, -84.3319161] },
  { id: 3, name: 'CW Wesley Chapel', address: '2389 Wesley Chapel Rd., Decatur, GA 30035', coordinates: [33.7190023, -84.21631169999999] },
  { id: 4, name: 'CW Greenbriar', address: '3030 Headland Dr. SW., Atlanta, GA 30311', coordinates: [33.6883924, -84.4873695] },
  { id: 5, name: 'CW Adamsville', address: '3571 Martin Luther King Jr Dr. SW., Atlanta, GA 30331', coordinates: [33.7599802, -84.5039022] },
  { id: 6, name: 'CW Stone Mountain', address: '5244 Memorial Dr., Stone Mountain, CA 30083', coordinates: [33.7991943, -84.22289839999999] },
  { id: 7, name: 'CW Grove Park', address: '2056 Donald Lee Hollowell Pkwy. NW., Atlanta GA, 30318', coordinates: [33.7762673, -84.4530443] },
  { id: 8, name: 'CW Victory Heights', address: '2104 E. Victory Dr., Savannah, GA 31404', coordinates: [32.041662, -81.0633482] },
] as {
  id: number;
  name: string;
  address: string;
  coordinates: [number, number];
}[];
